import {coreApi} from './core'

export const productsService = {

    getAll: () => coreApi.get('product'),
    getById: (id) => coreApi.get(`product?id=${id}`),
    create: (data) => coreApi.post('product', data),
    update: (data) => coreApi.put(`product`, data),
    delete: (id) => coreApi.delete(`product/${id}`),
    paginate: (offset) => coreApi.get(`product/${offset}`),

    /**
     * @deprecated
     * @param params
     */
    getAllProducts(params) {
    },

}
